import {
  createFileRoute, isRedirect, useLoaderData,
} from '@tanstack/react-router';
import { thirdPartyLoader, ThirdPartyLoaderResponse } from '../../../../utils/third-party-loader';
import ThirdPartyPage from '../../../../components/pages/third-party-page';

interface ThirdPartyLoaderParams {
  params: { accountSlug: string; trackingId: string };
}

const PersonalGuarantorRoute = () => {
  const loaderData = useLoaderData({ from: '/personal-guarantors/$accountSlug/$trackingId/' }) as ThirdPartyLoaderResponse;
  return <ThirdPartyPage
    loaderData={loaderData}
    routeFrom='/personal-guarantors/$accountSlug/$trackingId/'
         />;
};

export const Route = createFileRoute('/personal-guarantors/$accountSlug/$trackingId/')({
  loader: async ({ params: { accountSlug, trackingId } }: ThirdPartyLoaderParams) => {
    try {
      const result = await thirdPartyLoader({
        accountSlug,
        trackingId,
      });
      if (result.type === 'error') {
        window.DD_RUM?.addError(result.error, {
          source: 'personal-guarantor-loader',
          accountSlug,
          trackingId,
        });
      }
      return result;
    } catch (error) {
      if (isRedirect(error)) throw error;
      window.DD_RUM?.addError(error, {
        source: 'personal-guarantor-loader-unhandled',
        accountSlug,
        trackingId,
      });
      throw error;
    }
  },
  component: PersonalGuarantorRoute,
});
